import resume from '../assets/pdf/vedrajpoot_resume.pdf'
import image1 from '../assets/png/myimg1.jpg'

export const headerData = {
    name: 'Ved Rajpoot',
    title: "Software Developer",
    // desciption:"There wasn't a bird in the sky, but that was not what caught her attention. It was the clouds. The deep green that isn't the color of clouds, but came with these. She knew what was coming and she hoped she was prepared. ",
    desciption: "The river flowed without hesitation, yet it had no destination. It carved its path through stone, not out of will, but because it could do nothing else. He watched the water swirl and wondered—was he moving forward, or simply being carried?",
    // image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
    image: image1,
    resumePdf: resume
}
